import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { TrendingUpIcon, UsersIcon, TargetIcon, ArrowRightIcon } from 'lucide-react';
const heroSlides = [{
  title: 'The Home of Smart Betting Wins',
  subtitle: 'Join 20,000+ bettors using our trusted insights and enjoying a 90% success rate daily.',
  image: 'https://images.unsplash.com/photo-1579952363873-27f3bade9f55?w=800&q=80'
}, {
  title: 'Daily Accurate Predictions',
  subtitle: 'Your journey to consistent wins starts here — free predictions every single day.',
  image: 'https://images.unsplash.com/photo-1574629810360-7efbbe195018?w=800&q=80'
}, {
  title: 'Trusted by 20,000+ Bettors',
  subtitle: 'Proven 90% success rate across Africa. Join the winning community today.',
  image: 'https://images.unsplash.com/photo-1522778119026-d647f0596c20?w=800&q=80'
}];
export function Hero() {
  const [currentSlide, setCurrentSlide] = useState(0);
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide(prev => (prev + 1) % heroSlides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);
  return <div id="hero" className="relative w-full min-h-[90vh] md:min-h-[85vh] overflow-hidden" data-id="element-71">
      {/* Animated Background */}
      <div className="absolute inset-0 bg-gradient-to-br from-dark-base via-dark-card to-dark-base" data-id="element-72">
        <div className="absolute inset-0 opacity-20" data-id="element-73">
          <div className="absolute top-20 left-10 w-64 h-64 bg-neon-cyan rounded-full blur-[120px] animate-float" data-id="element-74"></div>
          <div className="absolute bottom-20 right-10 w-64 h-64 bg-neon-purple rounded-full blur-[120px] animate-float" style={{
          animationDelay: '1s'
        }} data-id="element-75"></div>
        </div>
      </div>

      {/* Hero Content */}
      <div className="relative z-10 container mx-auto px-4 pt-24 md:pt-28 pb-12" data-id="element-76">
        {/* Sliding Hero Cards */}
        <div className="relative h-[450px] md:h-[400px] mb-8" data-id="element-77">
          {heroSlides.map((slide, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: currentSlide === index ? 1 : 0,
          scale: currentSlide === index ? 1 : 0.9,
          x: currentSlide === index ? 0 : currentSlide > index ? -100 : 100
        }} transition={{
          duration: 0.7,
          ease: 'easeInOut'
        }} className="absolute inset-0" data-id="element-78">
              <div className="relative h-full bg-gradient-to-br from-dark-card to-dark-lighter rounded-3xl overflow-hidden border border-neon-cyan/20" data-id="element-79">
                {/* Background Image */}
                <div className="absolute inset-0 opacity-20" data-id="element-80">
                  <img src={slide.image} alt="Hero background" className="w-full h-full object-cover" data-id="element-81" />
                  <div className="absolute inset-0 bg-gradient-to-t from-dark-card via-dark-card/50 to-transparent" data-id="element-82"></div>
                </div>

                {/* Content */}
                <div className="relative z-10 h-full flex flex-col justify-center items-center text-center px-6 md:px-12 py-12" data-id="element-83">
                  <motion.h1 initial={{
                opacity: 0,
                y: 20
              }} animate={{
                opacity: 1,
                y: 0
              }} transition={{
                delay: 0.2
              }} className="text-3xl md:text-6xl font-black mb-4 md:mb-6 leading-tight" data-id="element-84">
                    <span className="text-gradient-cyan" data-id="element-85">{slide.title}</span>
                  </motion.h1>

                  <motion.p initial={{
                opacity: 0,
                y: 20
              }} animate={{
                opacity: 1,
                y: 0
              }} transition={{
                delay: 0.3
              }} className="text-base md:text-xl text-gray-300 mb-6 md:mb-8 max-w-2xl" data-id="element-86">
                    {slide.subtitle}
                  </motion.p>

                  {/* CTAs */}
                  <motion.div initial={{
                opacity: 0,
                y: 20
              }} animate={{
                opacity: 1,
                y: 0
              }} transition={{
                delay: 0.4
              }} className="flex flex-col sm:flex-row gap-3 md:gap-4 w-full sm:w-auto" data-id="element-87">
                    <a href="https://greenhsvip.site/" target="_blank" rel="noopener noreferrer" className="group relative px-6 md:px-8 py-3 md:py-4 bg-gradient-to-r from-neon-cyan to-cyan-600 rounded-xl font-bold text-base md:text-lg text-white overflow-hidden transition-all hover:scale-105 hover:shadow-[0_0_30px_rgba(6,182,212,0.6)]" data-id="element-88">
                      <span className="relative z-10 flex items-center justify-center gap-2" data-id="element-89">
                        Join VIP 🌟
                        <ArrowRightIcon className="w-4 h-4 md:w-5 md:h-5 group-hover:translate-x-1 transition-transform" data-id="element-90" />
                      </span>
                    </a>

                    <a href="https://t.me/+X8ENbuhiohkyOTU8" target="_blank" rel="noopener noreferrer" className="group px-6 md:px-8 py-3 md:py-4 bg-dark-card/80 backdrop-blur-sm border-2 border-neon-green rounded-xl font-bold text-base md:text-lg text-white transition-all hover:bg-neon-green/10 hover:scale-105" data-id="element-91">
                      <span className="flex items-center justify-center gap-2" data-id="element-92">
                        Join Free Channel
                        <TrendingUpIcon className="w-4 h-4 md:w-5 md:h-5 group-hover:translate-x-1 transition-transform" data-id="element-93" />
                      </span>
                    </a>
                  </motion.div>
                </div>
              </div>
            </motion.div>)}
        </div>

        {/* Slide Indicators */}
        <div className="flex justify-center gap-2 mb-12" data-id="element-94">
          {heroSlides.map((_, index) => <button key={index} onClick={() => setCurrentSlide(index)} className={`h-2 rounded-full transition-all ${currentSlide === index ? 'w-8 bg-neon-cyan' : 'w-2 bg-gray-600 hover:bg-gray-500'}`} data-id="element-95" />)}
        </div>

        {/* Stats Bar */}
        <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.5
      }} className="flex flex-wrap justify-center gap-3 md:gap-4 mb-12" data-id="element-96">
          <div className="flex items-center gap-2 bg-dark-card/80 backdrop-blur-sm px-4 py-2 rounded-full border border-neon-cyan/30" data-id="element-97">
            <UsersIcon className="w-4 h-4 md:w-5 md:h-5 text-neon-cyan" data-id="element-98" />
            <span className="text-xs md:text-sm font-semibold" data-id="element-99">
              20,000+ Active Members
            </span>
          </div>
          <div className="flex items-center gap-2 bg-dark-card/80 backdrop-blur-sm px-4 py-2 rounded-full border border-neon-green/30" data-id="element-100">
            <TargetIcon className="w-4 h-4 md:w-5 md:h-5 text-neon-green" data-id="element-101" />
            <span className="text-xs md:text-sm font-semibold" data-id="element-102">
              90% Success Rate
            </span>
          </div>
        </motion.div>

        {/* Value Props */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.6
      }} className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6" data-id="element-103">
          <div className="bg-dark-card/50 backdrop-blur-sm border border-neon-cyan/20 rounded-2xl p-5 md:p-6 text-center hover:border-neon-cyan/50 transition-colors" data-id="element-104">
            <div className="w-10 h-10 md:w-12 md:h-12 bg-neon-cyan/20 rounded-full flex items-center justify-center mx-auto mb-3 md:mb-4" data-id="element-105">
              <TargetIcon className="w-5 h-5 md:w-6 md:h-6 text-neon-cyan" data-id="element-106" />
            </div>
            <h3 className="font-bold text-base md:text-lg mb-2" data-id="element-107">
              Daily Accurate Football Predictions
            </h3>
            <p className="text-gray-400 text-xs md:text-sm" data-id="element-108">
              Carefully analyzed picks updated every day
            </p>
          </div>

          <div className="bg-dark-card/50 backdrop-blur-sm border border-neon-green/20 rounded-2xl p-5 md:p-6 text-center hover:border-neon-green/50 transition-colors" data-id="element-109">
            <div className="w-10 h-10 md:w-12 md:h-12 bg-neon-green/20 rounded-full flex items-center justify-center mx-auto mb-3 md:mb-4" data-id="element-110">
              <TrendingUpIcon className="w-5 h-5 md:w-6 md:h-6 text-neon-green" data-id="element-111" />
            </div>
            <h3 className="font-bold text-base md:text-lg mb-2" data-id="element-112">
              Proven 90% Success Rate
            </h3>
            <p className="text-gray-400 text-xs md:text-sm" data-id="element-113">
              Track record that speaks for itself
            </p>
          </div>

          <div className="bg-dark-card/50 backdrop-blur-sm border border-neon-purple/20 rounded-2xl p-5 md:p-6 text-center hover:border-neon-purple/50 transition-colors" data-id="element-114">
            <div className="w-10 h-10 md:w-12 md:h-12 bg-neon-purple/20 rounded-full flex items-center justify-center mx-auto mb-3 md:mb-4" data-id="element-115">
              <UsersIcon className="w-5 h-5 md:w-6 md:h-6 text-neon-purple" data-id="element-116" />
            </div>
            <h3 className="font-bold text-base md:text-lg mb-2" data-id="element-117">
              Trusted by 20,000+ Bettors
            </h3>
            <p className="text-gray-400 text-xs md:text-sm" data-id="element-118">
              Growing community across Africa
            </p>
          </div>
        </motion.div>
      </div>
    </div>;
}